import { createMuiTheme } from '@material-ui/core/styles';
import { body, divider, heading, iconLight, primary, primaryBlue, red, white, errorText } from './Colours';

export const muiMedicationsTheme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Source Sans Pro"',
            '-apple-system',
            'system-ui',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif'
        ].join(','),
        fontWeightRegular: 600,
        h5: {
            fontSize: '1.2rem' // 20px
        },
        body1: {
            fontSize: '1rem', // 16px
            fontWeight: 400
        },
        body2: {
            fontSize: '1rem', // 16px
            fontWeight: 400
        },
        button: {
            fontSize: 14,
            fontWeight: 600
        }
    },
    overrides: {
        MuiButton: {
            root: {
                fontSize: 14,
                borderRadius: 2,
                lineHeight: 'normal',
                padding: '10px 16px'
            },
            label: {
                textTransform: 'none'
            },
            text: {
                padding: '10px 16px'
            },
            sizeSmall: {
                fontSize: 14,
                padding: '8px 12px'
            },
            sizeLarge: {
                fontSize: 16,
                padding: '12px 16px'
            },
            contained: {
                border: 'transparent'
            },
            startIcon: {
                marginLeft: 0,
                marginRight: 0,
                '&$iconSizeSmall': {
                    marginLeft: 0,
                    marginRight: 6
                },
                '&$iconSizeMedium': {
                    marginLeft: 0,
                    marginRight: 8
                },
                '&$iconSizeLarge': {
                    marginLeft: 0,
                    marginRight: 8
                }
            },
            endIcon: {
                marginLeft: 0,
                marginRight: 0,
                '&$iconSizeSmall': {
                    marginLeft: 6,
                    marginRight: 0
                },
                '&$iconSizeMedium': {
                    marginLeft: 8,
                    marginRight: 0
                },
                '&$iconSizeLarge': {
                    marginLeft: 8,
                    marginRight: 0
                }
            }
        },
        MuiInputBase: {
            input: {
                height: '22px'
            }
        },
        MuiInputLabel: {
            root: {
                color: body
            },
            shrink: {
                color: heading,
                transform: `scale(0.88)`
            }
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottom: '1px solid ' + divider
                },
                '&:hover:not($disabled):before': {
                    borderBottom: `2px solid ` + heading
                },
                '&$error:after': {
                    borderBottomColor: errorText
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: heading,
                '&$error': {
                    color: heading
                }
            },
            asterisk: {
                color: red
            }
        },
        MuiMenuItem: {
            root: {
                fontWeight: 400,
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'initial' // IE11 does not handle justifyContent with margins
            }
        },
        MuiChip: {
            root: {
                height: 28
            }
        },
        MuiToolbar: {
            regular: {
                paddingRight: 12
            }
        },
        MuiStepConnector: {
            alternativeLabel: {
                top: 16,
                left: 'calc(-50% + 16px)',
                right: 'calc(50% + 16px)'
            }
        },
        MuiTableCell: {
            root: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 40
            }
        },
        MuiTab: {
            labelIcon: {
                margin: 0,
                marginRight: 8
            },
            textColorInherit: {
                color: body,
                opacity: 1
            }
        },
        MuiFormControlLabel: {
            root: {
                '&$disabled': {
                    cursor: 'not-allowed'
                }
            },
            label: {
                color: heading,
                '&$disabled': {
                    color: iconLight
                }
            }
        },
        MuiSwitch: {
            switchBase: {
                color: white,
                'span&$checked': {
                    color: white
                },
                'span&$checked + $track': {
                    opacity: 1
                }
            },
            colorSecondary: {
                'span&$disabled + $track': {
                    backgroundColor: iconLight
                }
            },
            track: {
                backgroundColor: iconLight,
                opacity: 1
            }
        },
        MuiIconButton: {
            root: {
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }
            }
        },
        MuiFormHelperText: {
            root: {
                '&$error': {
                    color: errorText
                }
            }
        }
    },
    palette: {
        primary: {
            light: primaryBlue,
            main: primaryBlue,
            dark: primaryBlue
        },
        secondary: {
            light: primaryBlue,
            main: primaryBlue,
            dark: primaryBlue
        }
    }
});
